var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{attrs:{"type":"warning","icon":_vm.mdiAlertCircle}},[_vm._v(" Keine Berechtigung auf "+_vm._s(_vm.url)+" ")]),_c('v-btn',{staticClass:"primary",on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.mdiChevronLeft)+" ")]),_vm._v(" Zurück ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }